import { render, staticRenderFns } from "./TrainConfigNameCell.vue?vue&type=template&id=2098bf0a&scoped=true"
import script from "./TrainConfigNameCell.vue?vue&type=script&lang=js"
export * from "./TrainConfigNameCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098bf0a",
  null
  
)

export default component.exports